import { render, staticRenderFns } from "./classAlbum.vue?vue&type=template&id=7636f17c&scoped=true&"
import script from "./classAlbum.vue?vue&type=script&lang=js&"
export * from "./classAlbum.vue?vue&type=script&lang=js&"
import style0 from "./classAlbum.vue?vue&type=style&index=0&id=7636f17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636f17c",
  null
  
)

export default component.exports